module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "gpk-editor"
    }
  }, [_c('textarea', {
    staticClass: "input",
    domProps: {
      "value": _vm.input
    },
    on: {
      "input": _vm.update,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.enter($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "preview",
    domProps: {
      "innerHTML": _vm._s(_vm.compiledMarkdown)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-890ba974!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gpkeditor/GPKEditor.vue
// module id = 17
// module chunks = 1